import { useEffect, useState } from "react";

export const useScript = (url: string, name: string) => {
  const [lib, setLib] = useState({});

  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    script.async = true;
    script.onload = () => setLib({ [name]: window?.[name as any] });

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url, name]);

  return lib;
};
